<template>
  <GMapMap :center="center" :zoom="6" style="height: 500px">
    <GMapCluster>
      <GMapMarker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :clickable="true"
        @click="OpenLocation()"
      >
        <GMapInfoWindow>
          <div>A Facility <MyComponent /></div>
        </GMapInfoWindow>
      </GMapMarker>
    </GMapCluster>
  </GMapMap>
</template>

<script>
export default {
  name: "SearchResultsMapView",

  data() {
    return {
      center: { lat: 39.7817, lng: -89.6501 },
      markers: [
        {
          position: {
            lat: 39.7817,
            lng: -89.6501,
          },
        },
        {
          position: {
            lat: 41.8781,
            lng: -87.6298,
          },
        }, // Along list of clusters
      ],
    };
  },
  methods: {
    OpenLocation() {
      console.log("option clicked");
    },
  },
};
</script>